import { __assign } from "tslib";
import { getLegacyBaseDriverFromWrapper } from '../../common/base-driver';
import { CodeEditor } from './code-editor';
import { renderAndMountComponent } from '@wix/answers-lib';
import * as React from 'react';
export var createCodeEditorLegacyDriver = function (wrapper) {
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, '.code-editor', CodeEditor.name);
    var CodeMirror = baseDriver.find('.CodeMirror').elem.CodeMirror;
    return {
        getValue: function () { return CodeMirror.getValue(); },
        enterValue: function (value) { return CodeMirror.setValue(value); },
        hasPlaceholder: function () { return baseDriver.isChildVisible('pre.CodeMirror-placeholder'); },
        getPlaceholder: function () { return baseDriver.find('pre.CodeMirror-placeholder').getText(); }
    };
};
export var createCodeEditorLegacy = function (props) {
    var elem = renderAndMountComponent(React.createElement(CodeEditor, __assign({}, props)));
    return createCodeEditorLegacyDriver(elem);
};
//# sourceMappingURL=code-editor.legacy.driver.js.map